// ROUTE URL
export const ROUTE_URL = {
    LOGIN: 'login',
    REGISTER: 'register',
    REGISTER_SUCCESS: 'register-success',
    FORGOT_PASSWORD: 'forgot-password',
    DASHBOARD: 'dashboard',
    GPUHUB: 'gpuhub',
    CPUHUB: 'cpuhub',
    FIXED_RENTAL: 'fixed-rental',
    PAYMENT_MANAGEMENT: 'payment-management',
    STAKE_MANAGEMENT: 'stake-management',
    RECHARGE: 'recharge',
    BILLING_HISTORY: 'billing-history',
    PAYMENT_SUCCESS: 'payment-success',
    SUPPORT: 'support',
    GET_HELP: 'get-help',
    EXTRA_SERVICE_CONTAINER: 'extra-service',
    AFFILIATE_PROGRAM: 'affiliate-program',
    CUSTOMER_INFORMATION: 'customer-information',
    COUPONS: 'coupons',
    SETTINGS: 'settings',
    DOWNLOAD: 'download',
    USER_HISTORY: 'history',
    DEVELOPER_API: 'api',
    RENTAL_NEWS: 'rental-news',
    REACTIVATE_EXPIRED: 'reactivate-expired',
    REACTIVATE_SUCCESS: 'reactivate-success',
    REACTIVATE_CHANGE_PASSWORD: 're-active-account-update-password',
}
